import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import WaLink,{btnPrimary,btnOutline,btnAccent,eyebrow} from './WaLink';
import {bridal} from '../data/salon';

const carePhoto='https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/fd3776da43948e17e44adc7ef44169c0.webp';
const skinPhoto='https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/dcf6363f6076aa50a9fe2baa7ad8b579.webp';

const packages=[
  {name: 'The Intimate',price: '₹12,500',image: bridal[0].image,items: ['Bridal makeup','Hairstyling','Draping help']},
  {name: 'The Celebration',price: '₹21,000',image: bridal[1].image,items: ['Bridal makeup','Pre-bridal facial','Family guest makeup'],featured: true},
  {name: 'The Full Bloom',price: '₹32,000',image: bridal[2].image,items: ['Bridal makeup','Two pre-bridal services','Two family looks']},
];

function Packages() {
  return (
    <section id="packages" className="mx-auto max-w-[1280px] px-4 py-20 sm:px-6">
      <div className="mb-10 text-center">
        <span className={eyebrow}>Bridal packages</span>
        <h2 className="font-display mt-3 text-4xl text-[#0B3B36] sm:text-5xl">Made for your <em className="text-[#C8553D]">celebration.</em></h2>
      </div>
      <div className="grid gap-5 md:grid-cols-3">
        {packages.map((p)=> (
          <article key={p.name} className={`overflow-hidden rounded-2xl bg-white ${p.featured ? 'border-2 border-[#E9A23B] shadow-2xl md:-translate-y-3' : 'border border-[#0B3B36]/10'}`}>
            <div className="relative h-56">
              <img src={p.image} alt={`${p.name} package`} className="h-full w-full object-cover object-[center_25%]" />
              {p.featured && <span className="absolute left-4 top-4 rounded-full bg-[#E9A23B] px-3 py-1 text-[11px] font-bold text-[#0B3B36]">Most loved</span>}
            </div>
            <div className="p-6">
              <h3 className="font-display text-2xl text-[#0B3B36]">{p.name}</h3>
              <p className="font-display mt-2 text-3xl text-[#C8553D]">{p.price}<small className="font-sans text-xs text-[#4b5d59]"> onwards</small></p>
              <ul className="my-5 space-y-2 border-t border-[#0B3B36]/10 pt-4 text-sm text-[#4b5d59]">
                {p.items.map((it)=> (
                  <li key={it} className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiCheck} className="text-[#C8553D]" />{it}</li>
                ))}
              </ul>
              <WaLink className={`${p.featured ? btnPrimary : btnOutline} w-full`}>Enquire now</WaLink>
            </div>
          </article>
        ))}
      </div>
      <p className="mt-6 text-center text-xs text-[#4b5d59]">Demo prices for illustration. Enquire for a personal quote.</p>
    </section>
  );
}

function HairSkinCare() {
  return (
    <section className="bg-[#0B3B36] py-20 text-white">
      <div className="mx-auto grid max-w-[1280px] items-center gap-10 px-4 sm:px-6 lg:grid-cols-2">
        <div>
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#E9A23B]">Hair &amp; skin care</span>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl">Be good to <em className="text-[#E9A23B]">your glow.</em></h2>
          <div className="my-7 flex flex-wrap gap-3">
            {['Hair spa','Keratin care','Hydra facial','Gold facial','De-tan','Anti-acne'].map((t)=> (
              <WaLink key={t} className="rounded-full border border-white/30 px-5 py-2 text-sm transition hover:bg-[#E9A23B] hover:text-[#0B3B36]">{t}</WaLink>
            ))}
          </div>
          <WaLink className={btnAccent}>Find your treatment <SafeIcon icon={FiIcons.FiArrowUpRight} /></WaLink>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <img src={carePhoto} alt="Relaxing facial" className="h-[360px] w-full rounded-2xl object-cover" />
          <img src={skinPhoto} alt="Radiant skin" className="mt-10 h-[360px] w-full rounded-2xl object-cover" />
        </div>
      </div>
    </section>
  );
}

export {Packages,HairSkinCare};
